import * as React from 'react';
import Spin from 'antd/lib/spin';
import './Box.scss';

export interface IBoxProps {
	loading?: boolean;
	loadingText?: string;
	children?: React.ReactElement | React.ReactElement[];
}

const Box = (props: IBoxProps) => (<Spin spinning={props.loading} tip={props.loadingText}>
	<div className="Box">
		{props.children}
	</div>
</Spin>);

export default Box;
